
import 'react-responsive-calendar-picker/dist/index.css'
function _interopDefault(ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styled = _interopDefault(require('styled-components'));

function _extends() {
    //eslint-disable-next-line
    _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }

    strings.raw = raw;
    return strings;
}

var _path;

function _extends$1() {
    //eslint-disable-next-line
    _extends$1 = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    return _extends$1.apply(this, arguments);
}

function SvgLeft(props) {
    return /*#__PURE__*/React.createElement("svg", _extends$1({
        width: 8,
        height: 14,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
        d: "M.01 7c0 .25.096.5.287.692l6.02 6.02a.98.98 0 101.386-1.387L2.377 7l5.326-5.326A.98.98 0 006.316.286l-6.02 6.02a.978.978 0 00-.286.693z",
        fill: "#333"
    })));
}

var _path$1;

function _extends$2() {
    //eslint-disable-next-line
    _extends$2 = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    return _extends$2.apply(this, arguments);
}

function SvgRight(props) {
    return /*#__PURE__*/React.createElement("svg", _extends$2({
        width: 8,
        height: 14,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
        d: "M7.99 7c0 .25-.096.5-.287.692l-6.02 6.02a.98.98 0 11-1.386-1.387L5.623 7 .297 1.673A.98.98 0 011.684.286l6.02 6.02a.978.978 0 01.286.693z",
        fill: "#333"
    })));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var DatePicker = function DatePicker(_ref) {
    var children = _ref.children,
        dates = _ref.dates,
        setDates = _ref.setDates,
        _ref$noMonth = _ref.noMonth,
        noMonth = _ref$noMonth === void 0 ? 2 : _ref$noMonth,
        open = _ref.open,
        setOpen = _ref.setOpen,
        _ref$sticky = _ref.sticky,
        sticky = _ref$sticky === void 0 ? true : _ref$sticky,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? '' : _ref$className,
        style = _ref.style,
        _ref$mobile = _ref.mobile,
        mobile = _ref$mobile === void 0 ? false : _ref$mobile;

    var _useState = React.useState(noMonth),
        noOfMonth = _useState[0];

    var _useState2 = React.useState([{
        m: dates.checkin ? dates.checkin.getMonth() : new Date().getMonth(),
        y: dates.checkin ? dates.checkin.getFullYear() : new Date().getFullYear()
    }]),
        nShow = _useState2[0],
        setNShow = _useState2[1];

    var dateRef = React.useRef();
    React.useEffect(function () {
        function handleClickOutside(event) {
            if (dateRef.current && !dateRef.current.contains(event.target)) {
                if (sticky) setOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        //eslint-disable-next-line
    }, [dateRef]);
    React.useEffect(function () {
        var arr = [].concat(nShow);

        while (true) {
            if (arr.length === noOfMonth) {
                break;
            }

            if (arr[arr.length - 1].m === 11) {
                arr.push({
                    m: 0,
                    y: arr[arr.length - 1].y + 1
                });
            } else {
                arr.push({
                    m: arr[arr.length - 1].m + 1,
                    y: arr[arr.length - 1].y
                });
            }
        }

        setNShow(arr);
        //eslint-disable-next-line
    }, [noOfMonth]);

    var _useState3 = React.useState(mobile),
        mob = _useState3[0];

    var nextMonths = function nextMonths() {
        var newArr = nShow.map(function (ele) {
            if (ele.m === 11) {
                return {
                    m: 0,
                    y: ele.y + 1
                };
            }

            return {
                m: ele.m + 1,
                y: ele.y
            };
        });
        setNShow(newArr);
    };

    var prevMonths = function prevMonths() {
        var newArr = nShow.map(function (ele) {
            if (ele.m === 0) {
                return {
                    m: 11,
                    y: ele.y - 1
                };
            }

            return {
                m: ele.m - 1,
                y: ele.y
            };
        });
        setNShow(newArr);
    };

    var LeftButton = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    background: none;\n    border: 0;\n    left: 40px;\n    top: calc(1.5em + 20px);\n    cursor: pointer;\n  "])));
    var RightButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    background: none;\n    border: 0;\n    right: 40px;\n    top: calc(1.5em + 20px);\n    cursor: pointer;\n  "])));

    var handleScroll = function handleScroll(e) {
        var bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 10;

        if (bottom && mob) {
            var arr = [];

            if (nShow[nShow.length - 1].m === 11) {
                arr.push({
                    m: 0,
                    y: nShow[nShow.length - 1].y + 1
                });
            } else {
                arr.push({
                    m: nShow[nShow.length - 1].m + 1,
                    y: nShow[nShow.length - 1].y
                });
            }

            setNShow([].concat(nShow, arr));
        }
    };

    return /*#__PURE__*/React__default.createElement("div", {
        className: 'date-picker ' + className,
        ref: dateRef,
        tabIndex: 0,
        id: "date-picker"
    }, children, open && /*#__PURE__*/React__default.createElement("div", {
        className: "date-picker-wrapper",
        onScroll: handleScroll,
        style: _extends({
            display: 'flex',
            gap: '20px',
            width: mob ? '100%' : 'fit-content',
            position: 'absolute',
            flexDirection: mob ? 'column' : 'row',
            background: '#FFFFFF',
            border: !mob && '1px solid #e5c0fc',
            boxSizing: 'border-box',
            boxShadow: !mob && '0px 0px 50px 4px rgba(221, 221, 221, 0.35)',
            borderRadius: '10px',
            padding: mob ? '20px 0' : '20px 40px',
            alignItems: mob && 'center',
            overflowY: mob && 'auto',
            maxHeight: mob && '400px',

        }, style)
    }, !mob && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LeftButton, {
        onClick: prevMonths
    }, /*#__PURE__*/React__default.createElement(SvgLeft, null)), /*#__PURE__*/React__default.createElement(RightButton, {
        onClick: nextMonths
    }, /*#__PURE__*/React__default.createElement(SvgRight, null))), nShow.slice(!mob ? nShow.length - 2 : 0, nShow.length).map(function (ele, indx) {
        return /*#__PURE__*/React__default.createElement(Months, {
            setDates: setDates,
            month: ele.m,
            year: ele.y,
            dates: dates,
            key: ele.m + "+" + ele.y,
            mob: mob
        });
    })));
};

var Months = function Months(_ref2) {
    var dates = _ref2.dates,
        setDates = _ref2.setDates,
        _ref2$month = _ref2.month,
        month = _ref2$month === void 0 ? new Date().getMonth() : _ref2$month,
        _ref2$year = _ref2.year,
        year = _ref2$year === void 0 ? new Date().getFullYear() : _ref2$year,
        mob = _ref2.mob;

    var _useState4 = React.useState({
        month: month,
        year: year
    }),
        changeMonth = _useState4[0];

    var _useState5 = React.useState({}),
        data = _useState5[0],
        setData = _useState5[1];

    React.useMemo(function () {
        //eslint-disable-next-line
        setData(getDaysInMonth(changeMonth.month, changeMonth.year));
        //eslint-disable-next-line
    }, [changeMonth]);
    React.useMemo(function () {
        if (new Date(dates.checkin) > new Date(dates.checkout)) {
            return setDates({
                checkin: dates.checkout,
                checkout: dates.checkin
            });
        }

        if (data.data) {
            var arr = data.data.map(function (i) {
                if (i.time === dates.checkin || i.time === dates.checkout) {
                    return _extends({}, i, {
                        color: '#9c1fe9'
                    });
                }

                if (dates.checkin < i.time && dates.checkout > i.time) {
                    return _extends({}, i, {
                        color: '#e5c0fc '
                    });
                }

                return _extends({}, i, {
                    color: ''
                });
            });
            setData({
                month: data.month,
                data: arr
            });
        }
        //eslint-disable-next-line
    }, [dates]);
    var MonthWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    width: fit-content;\n    h3 {\n      text-align: center;\n    }\n  "])));
    var MonthTitle = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 100%;\n    align-items: center;\n    font-family: Inter;\n    justify-content: center;\n  "])));
    var MonthContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    grid-template-columns: repeat(7, ", ");\n    display: grid;\n  "])), mob ? '40px' : '48px');
    var DayContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    font-family: Inter;\n    justify-content: center;\n    border-radius: 4px;\n    font-family: Inter;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 15px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    font-feature-settings: 'tnum' on, 'lnum' on;\n    color: #333333;\n    height: ", ";\n    cursor: pointer;\n    border: 1px solid white;\n    transition: 0.3s ease-in-out;\n    &:hover {\n      background: #e5c0fc;\n      border: 1px solid #e5c0fc;\n    }\n  "])), mob ? '40px' : '48px');
    var WeekDaysWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n    grid-template-columns: repeat(7, ", ");\n    display: grid;\n    div {\n      text-align: center;\n      font-family: Inter;\n      font-style: normal;\n      font-weight: 600;\n      font-size: 12px;\n      line-height: 150%;\n      color: #666666;\n    }\n  "])), mob ? '40px' : '48px');
    var H3 = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n    display: block;\n    text-align: center;\n    font-size: 1.17em;\n    margin-block-start: 1em;\n    margin-block-end: 1em;\n    margin-inline-start: 0px;\n    margin-inline-end: 0px;\n    font-weight: bold;\n  "])));
    React.useEffect(function () {
        if (data.data) {
            var arr = data.data.map(function (i) {
                if (i.time && (i.time.toDateString() === (dates.checkin && dates.checkin.toDateString()) || i.time.toDateString() === (dates.checkout && dates.checkout.toDateString()))) {
                    return _extends({}, i, {
                        color: '#9c1fe9'
                    });
                }

                if (i.time && (i.time === dates.checkin || i.time === dates.checkout)) {
                    return _extends({}, i, {
                        color: '#3564E2'
                    });
                }

                if (dates.checkin < i.time && dates.checkout > i.time) {
                    return _extends({}, i, {
                        color: '#e5c0fc '
                    });
                }

                return _extends({}, i, {
                    color: ''
                });
            });
            setData({
                month: data.month,
                data: arr
            });
        }
        //eslint-disable-next-line
    }, []);
    return /*#__PURE__*/React__default.createElement(MonthWrapper, null, /*#__PURE__*/React__default.createElement(MonthTitle, null, data.data && /*#__PURE__*/React__default.createElement(H3, null, data.month, "\xA0", year)), /*#__PURE__*/React__default.createElement(WeekDaysWrapper, null, /*#__PURE__*/React__default.createElement("div", null, "Sun"), /*#__PURE__*/React__default.createElement("div", null, "Mon"), /*#__PURE__*/React__default.createElement("div", null, "Tue"), /*#__PURE__*/React__default.createElement("div", null, "Wed"), /*#__PURE__*/React__default.createElement("div", null, "Thu"), /*#__PURE__*/React__default.createElement("div", null, "Fri"), /*#__PURE__*/React__default.createElement("div", null, "Sat")), /*#__PURE__*/React__default.createElement(MonthContainer, null, data.data && data.data.map(function (ele, indx) {
        return /*#__PURE__*/React__default.createElement(DayContainer, {
            style: {
                background: ele.color,
                color: ele.color ? ele.color === '#e5c0fc ' ? 'black' : 'white' : !ele.active ? 'lightgray' : 'black'
            },
            onClick: function onClick() {
                if (ele.active) {
                    if (dates.checkin < dates.checkout) {
                        return setDates({
                            checkin: '',
                            checkout: ''
                        });
                    }

                    if (dates.checkin !== '' && dates.checkout !== '') {
                        return setDates({
                            checkin: "",
                            checkout: ""
                        });
                    }


                    if (dates.checkin === '') {
                        setDates(_extends({}, dates, {
                            checkin: ele.time
                        }));
                    } else if (dates.checkin !== '') {
                        setDates(_extends({}, dates, {
                            checkout: ele.time
                        }));
                    }
                }
            },
            key: ele.date + "-" + ele.day + "-" + indx
        }, ele.date);
    })));
};

var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function getDaysInMonth(month, year) {
    var date = new Date(year, month, 1);
    var days = [];

    while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }

    var arr = days.map(function (ele) {
        if (new Date() < ele) {
            return {
                active: false,
                day: new Date(ele).getDay(),
                date: new Date(ele).getDate(),
                time: new Date(ele)
            };
        }

        return {
            active: true,
            day: new Date(ele).getDay(),
            date: new Date(ele).getDate(),
            time: new Date(ele)
        };
    });
    var fillerArr = [0, 1, 2, 3, 4, 5, 6];
    var fillArr = [].concat(fillerArr.slice(0, arr[0].time.getDay()), arr);
    return {
        month: monthNames[month],
        data: fillArr
    };
}

export default DatePicker;

